var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEvEverywhereDefault = function SvgEvEverywhereDefault(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.8 103.9",
    height: 40,
    "aria-labelledby": titleId,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "ev-everywhere-title"
  }, "EV Everywhere") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "ev-everywhere-title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 66.9c8.1 0 14.6-6.5 14.6-14.6s-6.5-14.6-14.6-14.6S0 44.2 0 52.3s6.5 14.6 14.6 14.6zm51.6 22.7c-.2 8.1-6.8 14.5-14.9 14.3-8.1-.2-14.5-6.8-14.3-14.9.2-7.9 6.6-14.3 14.6-14.3h.3c12.4 0 22.5-9.9 22.7-22.3v-.3c.1-12.5-10-22.8-22.5-22.9h-.6c-8.1 0-14.6-6.5-14.6-14.6S43.4 0 51.5 0c8 0 14.5 6.5 14.6 14.5v.4c0 12.5 10.2 22.7 22.7 22.7h.3c8.1 0 14.6 6.5 14.7 14.5 0 8.1-6.5 14.6-14.6 14.7h-.4c-12.5 0-22.7 10.2-22.6 22.8z",
    fill: "#37939f"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEvEverywhereDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ev-everywhere-default.86ff1e53efb278f0fda591883594b97d.svg";